import {LANG} from './Config';

// Liste utilisée pour les champs "nationalité" (value = nom canonique français,
// envoyé tel quel au backend). Mêmes entrées que dans Profil.js / FormRegister.js
// d'origine, dont les entrées « destination » à la fin (Bolivie - humanitaire, etc.).
export const NATIONALITIES = [
    {value: 'Afghanistan', fr: 'Afghanistan', en: 'Afghanistan'},
    {value: 'Afrique du Sud', fr: 'Afrique du Sud', en: 'South Africa'},
    {value: 'Aland (Îles)', fr: 'Aland (Îles)', en: 'Aland Islands'},
    {value: 'Albanie', fr: 'Albanie', en: 'Albania'},
    {value: 'Algérie', fr: 'Algérie', en: 'Algeria'},
    {value: 'Allemagne', fr: 'Allemagne', en: 'Germany'},
    {value: 'Andorre', fr: 'Andorre', en: 'Andorra'},
    {value: 'Angola', fr: 'Angola', en: 'Angola'},
    {value: 'Anguilla', fr: 'Anguilla', en: 'Anguilla'},
    {value: 'Antarctique', fr: 'Antarctique', en: 'Antarctica'},
    {value: 'Antigua et Barbuda', fr: 'Antigua et Barbuda', en: 'Antigua and Barbuda'},
    {value: 'Antilles néerlandaises', fr: 'Antilles néerlandaises', en: 'Netherlands Antilles'},
    {value: 'Arabie Saoudite', fr: 'Arabie Saoudite', en: 'Saudi Arabia'},
    {value: 'Argentine', fr: 'Argentine', en: 'Argentina'},
    {value: 'Arménie', fr: 'Arménie', en: 'Armenia'},
    {value: 'Aruba', fr: 'Aruba', en: 'Aruba'},
    {value: 'Australie', fr: 'Australie', en: 'Australia'},
    {value: 'Autriche', fr: 'Autriche', en: 'Austria'},
    {value: 'Azerbaïdjan', fr: 'Azerbaïdjan', en: 'Azerbaijan'},
    {value: 'Bahamas', fr: 'Bahamas', en: 'Bahamas'},
    {value: 'Bahreïn', fr: 'Bahreïn', en: 'Bahrain'},
    {value: 'Bangladesh', fr: 'Bangladesh', en: 'Bangladesh'},
    {value: 'Barbade', fr: 'Barbade', en: 'Barbados'},
    {value: 'Belgique', fr: 'Belgique', en: 'Belgium'},
    {value: 'Belize', fr: 'Belize', en: 'Belize'},
    {value: 'Bénin', fr: 'Bénin', en: 'Benin'},
    {value: 'Bermudes', fr: 'Bermudes', en: 'Bermuda'},
    {value: 'Bhutan', fr: 'Bhutan', en: 'Bhutan'},
    {value: 'Biélorussie', fr: 'Biélorussie', en: 'Belarus'},
    {value: 'Bolivie', fr: 'Bolivie', en: 'Bolivia'},
    {value: 'Bosnie-Herzégovine', fr: 'Bosnie-Herzégovine', en: 'Bosnia and Herzegovina'},
    {value: 'Botswana', fr: 'Botswana', en: 'Botswana'},
    {value: 'Bouvet (Île)', fr: 'Bouvet (Île)', en: 'Bouvet Island'},
    {value: 'Brésil', fr: 'Brésil', en: 'Brazil'},
    {value: 'Brunei', fr: 'Brunei', en: 'Brunei'},
    {value: 'Bulgarie', fr: 'Bulgarie', en: 'Bulgaria'},
    {value: 'Burkina Faso', fr: 'Burkina Faso', en: 'Burkina Faso'},
    {value: 'Burundi', fr: 'Burundi', en: 'Burundi'},
    {value: 'Caïmans (Îles)', fr: 'Caïmans (Îles)', en: 'Cayman Islands'},
    {value: 'Cambodge', fr: 'Cambodge', en: 'Cambodia'},
    {value: 'Cameroun', fr: 'Cameroun', en: 'Cameroon'},
    {value: 'Canada', fr: 'Canada', en: 'Canada'},
    {value: 'Cap Vert', fr: 'Cap Vert', en: 'Cape Verde'},
    {value: 'Chili', fr: 'Chili', en: 'Chile'},
    {value: 'Chine', fr: 'Chine', en: 'China'},
    {value: 'Christmas (Îles)', fr: 'Christmas (Îles)', en: 'Christmas Island'},
    {value: 'Chypre', fr: 'Chypre', en: 'Cyprus'},
    {value: 'Cocos', fr: 'Cocos', en: 'Cocos (Keeling) Islands'},
    {value: 'Colombie', fr: 'Colombie', en: 'Colombia'},
    {value: 'Comores', fr: 'Comores', en: 'Comoros'},
    {value: 'Congo', fr: 'Congo', en: 'Congo'},
    {value: 'Congo, République démocratique du (Congo)', fr: 'Congo, République démocratique du (Congo)', en: 'Congo, Democratic Republic of the'},
    {value: 'Cook (Îles)', fr: 'Cook (Îles)', en: 'Cook Islands'},
    {value: 'Corée du Nord', fr: 'Corée du Nord', en: 'North Korea'},
    {value: 'Corée du Sud', fr: 'Corée du Sud', en: 'South Korea'},
    {value: 'Costa Rica', fr: 'Costa Rica', en: 'Costa Rica'},
    {value: "Côte d'Ivoire", fr: "Côte d'Ivoire", en: 'Ivory Coast'},
    {value: 'Croatie', fr: 'Croatie', en: 'Croatia'},
    {value: 'Cuba', fr: 'Cuba', en: 'Cuba'},
    {value: 'Danemark', fr: 'Danemark', en: 'Denmark'},
    {value: 'Dépendances américaines du Pacifique', fr: 'Dépendances américaines du Pacifique', en: 'United States Minor Outlying Islands'},
    {value: 'Djibouti', fr: 'Djibouti', en: 'Djibouti'},
    {value: 'Dominique', fr: 'Dominique', en: 'Dominica'},
    {value: 'Égypte', fr: 'Égypte', en: 'Egypt'},
    {value: 'Émirats Arabes Unis', fr: 'Émirats Arabes Unis', en: 'United Arab Emirates'},
    {value: 'Équateur', fr: 'Équateur', en: 'Ecuador'},
    {value: 'Érythrée', fr: 'Érythrée', en: 'Eritrea'},
    {value: 'Espagne', fr: 'Espagne', en: 'Spain'},
    {value: 'Estonie', fr: 'Estonie', en: 'Estonia'},
    {value: 'États-Unis', fr: 'États-Unis', en: 'United States'},
    {value: 'Éthiopie', fr: 'Éthiopie', en: 'Ethiopia'},
    {value: 'Faroe (Îles)', fr: 'Faroe (Îles)', en: 'Faroe Islands'},
    {value: 'Fidji', fr: 'Fidji', en: 'Fiji'},
    {value: 'Finlande', fr: 'Finlande', en: 'Finland'},
    {value: 'France', fr: 'France', en: 'France'},
    {value: 'Gabon', fr: 'Gabon', en: 'Gabon'},
    {value: 'Gambie', fr: 'Gambie', en: 'Gambia'},
    {value: 'Géorgie', fr: 'Géorgie', en: 'Georgia'},
    {value: 'Géorgie du Sud et îles Sandwich du Sud', fr: 'Géorgie du Sud et îles Sandwich du Sud', en: 'South Georgia and the South Sandwich Islands'},
    {value: 'Ghana', fr: 'Ghana', en: 'Ghana'},
    {value: 'Gibraltar', fr: 'Gibraltar', en: 'Gibraltar'},
    {value: 'Grèce', fr: 'Grèce', en: 'Greece'},
    {value: 'Grenade', fr: 'Grenade', en: 'Grenada'},
    {value: 'Groenland', fr: 'Groenland', en: 'Greenland'},
    {value: 'Guadeloupe', fr: 'Guadeloupe', en: 'Guadeloupe'},
    {value: 'Guam', fr: 'Guam', en: 'Guam'},
    {value: 'Guatemala', fr: 'Guatemala', en: 'Guatemala'},
    {value: 'Guernesey', fr: 'Guernesey', en: 'Guernsey'},
    {value: 'Guinée', fr: 'Guinée', en: 'Guinea'},
    {value: 'Guinée-Bissau', fr: 'Guinée-Bissau', en: 'Guinea-Bissau'},
    {value: 'Guinée équatoriale', fr: 'Guinée équatoriale', en: 'Equatorial Guinea'},
    {value: 'Guyane', fr: 'Guyane', en: 'Guyana'},
    {value: 'Guyane française', fr: 'Guyane française', en: 'French Guiana'},
    {value: 'Haïti', fr: 'Haïti', en: 'Haiti'},
    {value: 'Heard et McDonald (Îles)', fr: 'Heard et McDonald (Îles)', en: 'Heard Island and McDonald Islands'},
    {value: 'Honduras', fr: 'Honduras', en: 'Honduras'},
    {value: 'Hong-Kong', fr: 'Hong-Kong', en: 'Hong Kong'},
    {value: 'Hongrie', fr: 'Hongrie', en: 'Hungary'},
    {value: 'Îles vierges britanniques', fr: 'Îles vierges britanniques', en: 'British Virgin Islands'},
    {value: 'Inde', fr: 'Inde', en: 'India'},
    {value: 'Inde du Nord Delhi', fr: 'Inde du Nord Delhi', en: 'India - North Delhi'},
    {value: 'Inde du Sud', fr: 'Inde du Sud', en: 'India - South'},
    {value: 'Indonésie', fr: 'Indonésie', en: 'Indonesia'},
    {value: 'Irak', fr: 'Irak', en: 'Iraq'},
    {value: 'Iran', fr: 'Iran', en: 'Iran'},
    {value: 'Irlande', fr: 'Irlande', en: 'Ireland'},
    {value: 'Islande', fr: 'Islande', en: 'Iceland'},
    {value: 'Israël', fr: 'Israël', en: 'Israel'},
    {value: 'Italie', fr: 'Italie', en: 'Italy'},
    {value: 'Jamaïque', fr: 'Jamaïque', en: 'Jamaica'},
    {value: 'Japon', fr: 'Japon', en: 'Japan'},
    {value: 'Jersey', fr: 'Jersey', en: 'Jersey'},
    {value: 'Jordanie', fr: 'Jordanie', en: 'Jordan'},
    {value: 'Kazakhstan', fr: 'Kazakhstan', en: 'Kazakhstan'},
    {value: 'Kenya', fr: 'Kenya', en: 'Kenya'},
    {value: 'Kirghizistan', fr: 'Kirghizistan', en: 'Kyrgyzstan'},
    {value: 'Kiribati', fr: 'Kiribati', en: 'Kiribati'},
    {value: 'Koweït', fr: 'Koweït', en: 'Kuwait'},
    {value: 'Laos', fr: 'Laos', en: 'Laos'},
    {value: 'Lesotho', fr: 'Lesotho', en: 'Lesotho'},
    {value: 'Lettonie', fr: 'Lettonie', en: 'Latvia'},
    {value: 'Liban', fr: 'Liban', en: 'Lebanon'},
    {value: 'Liberia', fr: 'Liberia', en: 'Liberia'},
    {value: 'Libye', fr: 'Libye', en: 'Libya'},
    {value: 'Liechtenstein', fr: 'Liechtenstein', en: 'Liechtenstein'},
    {value: 'Lituanie', fr: 'Lituanie', en: 'Lithuania'},
    {value: 'Luxembourg', fr: 'Luxembourg', en: 'Luxembourg'},
    {value: 'Macao', fr: 'Macao', en: 'Macao'},
    {value: 'Macédoine', fr: 'Macédoine', en: 'North Macedonia'},
    {value: 'Madagascar', fr: 'Madagascar', en: 'Madagascar'},
    {value: 'Malaisie', fr: 'Malaisie', en: 'Malaysia'},
    {value: 'Malawi', fr: 'Malawi', en: 'Malawi'},
    {value: 'Maldives', fr: 'Maldives', en: 'Maldives'},
    {value: 'Mali', fr: 'Mali', en: 'Mali'},
    {value: 'Malouines (Îles)', fr: 'Malouines (Îles)', en: 'Falkland Islands'},
    {value: 'Malte', fr: 'Malte', en: 'Malta'},
    {value: 'Man (Île)', fr: 'Man (Île)', en: 'Isle of Man'},
    {value: 'Mariannes du Nord (Commonwealth des îles)', fr: 'Mariannes du Nord (Commonwealth des îles)', en: 'Northern Mariana Islands'},
    {value: 'Maroc', fr: 'Maroc', en: 'Morocco'},
    {value: 'Marshall (Îles)', fr: 'Marshall (Îles)', en: 'Marshall Islands'},
    {value: 'Martinique', fr: 'Martinique', en: 'Martinique'},
    {value: 'Maurice (Île)', fr: 'Maurice (Île)', en: 'Mauritius'},
    {value: 'Mauritanie', fr: 'Mauritanie', en: 'Mauritania'},
    {value: 'Mayotte', fr: 'Mayotte', en: 'Mayotte'},
    {value: 'Mexique', fr: 'Mexique', en: 'Mexico'},
    {value: 'Micronésie', fr: 'Micronésie', en: 'Micronesia'},
    {value: 'Moldavie', fr: 'Moldavie', en: 'Moldova'},
    {value: 'Monaco', fr: 'Monaco', en: 'Monaco'},
    {value: 'Mongolie', fr: 'Mongolie', en: 'Mongolia'},
    {value: 'Monténégro', fr: 'Monténégro', en: 'Montenegro'},
    {value: 'Montserrat', fr: 'Montserrat', en: 'Montserrat'},
    {value: 'Mozambique', fr: 'Mozambique', en: 'Mozambique'},
    {value: 'Myanmar', fr: 'Myanmar', en: 'Myanmar'},
    {value: 'Namibie', fr: 'Namibie', en: 'Namibia'},
    {value: 'Nauru', fr: 'Nauru', en: 'Nauru'},
    {value: 'Népal', fr: 'Népal', en: 'Nepal'},
    {value: 'Nicaragua', fr: 'Nicaragua', en: 'Nicaragua'},
    {value: 'Niger', fr: 'Niger', en: 'Niger'},
    {value: 'Nigéria', fr: 'Nigéria', en: 'Nigeria'},
    {value: 'Niue', fr: 'Niue', en: 'Niue'},
    {value: 'Norfolk (Île de)', fr: 'Norfolk (Île de)', en: 'Norfolk Island'},
    {value: 'Norvège', fr: 'Norvège', en: 'Norway'},
    {value: 'Nouvelle-Calédonie', fr: 'Nouvelle-Calédonie', en: 'New Caledonia'},
    {value: 'Nouvelle-Zélande', fr: 'Nouvelle-Zélande', en: 'New Zealand'},
    {value: 'Oman', fr: 'Oman', en: 'Oman'},
    {value: 'Ouganda', fr: 'Ouganda', en: 'Uganda'},
    {value: 'Ouzbékistan', fr: 'Ouzbékistan', en: 'Uzbekistan'},
    {value: 'Pakistan', fr: 'Pakistan', en: 'Pakistan'},
    {value: 'Palau', fr: 'Palau', en: 'Palau'},
    {value: 'Panama', fr: 'Panama', en: 'Panama'},
    {value: 'Papouasie-Nouvelle Guinée', fr: 'Papouasie-Nouvelle Guinée', en: 'Papua New Guinea'},
    {value: 'Paraguay', fr: 'Paraguay', en: 'Paraguay'},
    {value: 'Pays-Bas', fr: 'Pays-Bas', en: 'Netherlands'},
    {value: 'Pérou', fr: 'Pérou', en: 'Peru'},
    {value: 'Philippines', fr: 'Philippines', en: 'Philippines'},
    {value: 'Pitcairn (Île)', fr: 'Pitcairn (Île)', en: 'Pitcairn Islands'},
    {value: 'Pologne', fr: 'Pologne', en: 'Poland'},
    {value: 'Polynésie française', fr: 'Polynésie française', en: 'French Polynesia'},
    {value: 'Porto Rico', fr: 'Porto Rico', en: 'Puerto Rico'},
    {value: 'Portugal', fr: 'Portugal', en: 'Portugal'},
    {value: 'Qatar', fr: 'Qatar', en: 'Qatar'},
    {value: 'République Centrafricaine', fr: 'République Centrafricaine', en: 'Central African Republic'},
    {value: 'République Dominicaine', fr: 'République Dominicaine', en: 'Dominican Republic'},
    {value: 'République Tchèque', fr: 'République Tchèque', en: 'Czech Republic'},
    {value: 'Réunion (Île de la)', fr: 'Réunion (Île de la)', en: 'Réunion'},
    {value: 'Roumanie', fr: 'Roumanie', en: 'Romania'},
    {value: 'Royaume-Uni', fr: 'Royaume-Uni', en: 'United Kingdom'},
    {value: 'Russie', fr: 'Russie', en: 'Russia'},
    {value: 'Rwanda', fr: 'Rwanda', en: 'Rwanda'},
    {value: 'Sahara oriental', fr: 'Sahara oriental', en: 'Western Sahara'},
    {value: 'Sainte-Hélène', fr: 'Sainte-Hélène', en: 'Saint Helena'},
    {value: 'Sainte-Lucie', fr: 'Sainte-Lucie', en: 'Saint Lucia'},
    {value: 'Saint-Kitts-et-Nevis', fr: 'Saint-Kitts-et-Nevis', en: 'Saint Kitts and Nevis'},
    {value: 'Saint-Marin', fr: 'Saint-Marin', en: 'San Marino'},
    {value: 'Saint-Pierre-et-Miquelon', fr: 'Saint-Pierre-et-Miquelon', en: 'Saint Pierre and Miquelon'},
    {value: 'Saint-Vincent et les Grenadines', fr: 'Saint-Vincent et les Grenadines', en: 'Saint Vincent and the Grenadines'},
    {value: 'Salvador', fr: 'Salvador', en: 'El Salvador'},
    {value: 'Samoa', fr: 'Samoa', en: 'Samoa'},
    {value: 'Samoa américaines', fr: 'Samoa américaines', en: 'American Samoa'},
    {value: 'São Tomé et Príncipe', fr: 'São Tomé et Príncipe', en: 'São Tomé and Príncipe'},
    {value: 'Sénégal', fr: 'Sénégal', en: 'Senegal'},
    {value: 'Serbie', fr: 'Serbie', en: 'Serbia'},
    {value: 'Serbie et Monténégro', fr: 'Serbie et Monténégro', en: 'Serbia and Montenegro'},
    {value: 'Seychelles', fr: 'Seychelles', en: 'Seychelles'},
    {value: 'Sierra Leone', fr: 'Sierra Leone', en: 'Sierra Leone'},
    {value: 'Singapour', fr: 'Singapour', en: 'Singapore'},
    {value: 'Slovaquie', fr: 'Slovaquie', en: 'Slovakia'},
    {value: 'Slovénie', fr: 'Slovénie', en: 'Slovenia'},
    {value: 'Solomon', fr: 'Solomon', en: 'Solomon Islands'},
    {value: 'Somalie', fr: 'Somalie', en: 'Somalia'},
    {value: 'Soudan', fr: 'Soudan', en: 'Sudan'},
    {value: 'Sri Lanka', fr: 'Sri Lanka', en: 'Sri Lanka'},
    {value: 'Suède', fr: 'Suède', en: 'Sweden'},
    {value: 'Suisse', fr: 'Suisse', en: 'Switzerland'},
    {value: 'Surinam', fr: 'Surinam', en: 'Suriname'},
    {value: 'Svalbard et Jan Mayen', fr: 'Svalbard et Jan Mayen', en: 'Svalbard and Jan Mayen'},
    {value: 'Swaziland', fr: 'Swaziland', en: 'Eswatini'},
    {value: 'Syrie', fr: 'Syrie', en: 'Syria'},
    {value: 'Tadjikistan', fr: 'Tadjikistan', en: 'Tajikistan'},
    {value: 'Taïwan', fr: 'Taïwan', en: 'Taiwan'},
    {value: 'Tanzanie', fr: 'Tanzanie', en: 'Tanzania'},
    {value: 'Tchad', fr: 'Tchad', en: 'Chad'},
    {value: "Territoires britanniques de l'Océan Indien", fr: "Territoires britanniques de l'Océan Indien", en: 'British Indian Ocean Territory'},
    {value: "Territoires d'Outre-mer (France)", fr: "Territoires d'Outre-mer (France)", en: 'French Overseas Territories'},
    {value: 'Territoires palestiniens', fr: 'Territoires palestiniens', en: 'Palestinian Territories'},
    {value: 'Thaïlande', fr: 'Thaïlande', en: 'Thailand'},
    {value: 'Thaïlande - Ayutthaya', fr: 'Thaïlande - Ayutthaya', en: 'Thailand - Ayutthaya'},
    {value: 'Thaïlande Chiang Mai/Nong Khai', fr: 'Thaïlande Chiang Mai/Nong Khai', en: 'Thailand - Chiang Mai/Nong Khai'},
    {value: 'Timor oriental', fr: 'Timor oriental', en: 'Timor-Leste'},
    {value: 'Togo', fr: 'Togo', en: 'Togo'},
    {value: 'Tokelau', fr: 'Tokelau', en: 'Tokelau'},
    {value: 'Tonga', fr: 'Tonga', en: 'Tonga'},
    {value: 'Trinidad et Tobago (Trinidad and Tobago)', fr: 'Trinidad et Tobago (Trinidad and Tobago)', en: 'Trinidad and Tobago'},
    {value: 'Tunisie', fr: 'Tunisie', en: 'Tunisia'},
    {value: 'Turkménistan', fr: 'Turkménistan', en: 'Turkmenistan'},
    {value: 'Turks et Caïcos (Îles)', fr: 'Turks et Caïcos (Îles)', en: 'Turks and Caicos Islands'},
    {value: 'Turquie', fr: 'Turquie', en: 'Turkey'},
    {value: 'Tuvalu', fr: 'Tuvalu', en: 'Tuvalu'},
    {value: 'Ukraine', fr: 'Ukraine', en: 'Ukraine'},
    {value: 'Uruguay', fr: 'Uruguay', en: 'Uruguay'},
    {value: 'Vanuatu', fr: 'Vanuatu', en: 'Vanuatu'},
    {value: 'Vatican', fr: 'Vatican', en: 'Vatican City'},
    {value: 'Venezuela', fr: 'Venezuela', en: 'Venezuela'},
    {value: 'Vierges américaines (Îles)', fr: 'Vierges américaines (Îles)', en: 'US Virgin Islands'},
    {value: 'Vietnam', fr: 'Vietnam', en: 'Vietnam'},
    {value: 'Vietnam Hanoi', fr: 'Vietnam Hanoi', en: 'Vietnam - Hanoi'},
    {value: 'Vietnam Ho Chi Minh', fr: 'Vietnam Ho Chi Minh', en: 'Vietnam - Ho Chi Minh'},
    {value: 'Wallis et Futuna', fr: 'Wallis et Futuna', en: 'Wallis and Futuna'},
    {value: 'Yémen', fr: 'Yémen', en: 'Yemen'},
    {value: 'Zambie', fr: 'Zambie', en: 'Zambia'},
    {value: 'Zimbabwe', fr: 'Zimbabwe', en: 'Zimbabwe'},
    {value: 'Bolivie - humanitaire', fr: 'Bolivie - humanitaire', en: 'Bolivia - humanitarian'},
    {value: 'Bolivie - éco-volontariat', fr: 'Bolivie - éco-volontariat', en: 'Bolivia - eco-volunteering'},
    {value: 'Equateur - humanitaire', fr: 'Equateur - humanitaire', en: 'Ecuador - humanitarian'},
    {value: 'Equateur - éco-volontariat', fr: 'Equateur - éco-volontariat', en: 'Ecuador - eco-volunteering'},
    {value: 'Iles Galapagos', fr: 'Iles Galapagos', en: 'Galapagos Islands'},
    {value: 'Sri Lanka – Eléphants', fr: 'Sri Lanka – Eléphants', en: 'Sri Lanka – Elephants'},
    {value: 'Australie – écovolontariat', fr: 'Australie – écovolontariat', en: 'Australia – eco-volunteering'},
    {value: 'Afrique du Sud - Soins animaliers', fr: 'Afrique du Sud - Soins animaliers', en: 'South Africa - Animal care'},
    {value: 'Afrique du Sud - Faune sauvage', fr: 'Afrique du Sud - Faune sauvage', en: 'South Africa - Wildlife'},
    {value: 'Majorque', fr: 'Majorque', en: 'Mallorca'},
    {value: 'Sri Lanka - Tortues', fr: 'Sri Lanka - Tortues', en: 'Sri Lanka - Turtles'},
    {value: 'Etats-Unis - chevaux', fr: 'Etats-Unis - chevaux', en: 'United States - Horses'},
    {value: 'Inde - Himalaya', fr: 'Inde - Himalaya', en: 'India - Himalaya'},
    {value: 'Tanzanie - Zanzibar', fr: 'Tanzanie - Zanzibar', en: 'Tanzania - Zanzibar'},
    {value: 'Thaïlande - animaux', fr: 'Thaïlande - animaux', en: 'Thailand - Animals'},
    {value: 'Thaïlande - Udon Thani', fr: 'Thaïlande - Udon Thani', en: 'Thailand - Udon Thani'},
    {value: 'Thaïlande - Bangkok/Chiang Mai', fr: 'Thaïlande - Bangkok/Chiang Mai', en: 'Thailand - Bangkok/Chiang Mai'},
];

// Liste utilisée pour les champs "pays" (value = code ISO 3166-1 alpha-2, ou code
// interne pour les variantes régionales et destinations). Même structure que
// NATIONALITIES côté label FR/EN.
export const COUNTRIES_ISO = [
    {value: 'AF', fr: 'Afghanistan', en: 'Afghanistan'},
    {value: 'ZA', fr: 'Afrique du Sud', en: 'South Africa'},
    {value: 'AX', fr: 'Aland (Îles)', en: 'Aland Islands'},
    {value: 'AL', fr: 'Albanie', en: 'Albania'},
    {value: 'DZ', fr: 'Algérie', en: 'Algeria'},
    {value: 'DE', fr: 'Allemagne', en: 'Germany'},
    {value: 'AD', fr: 'Andorre', en: 'Andorra'},
    {value: 'AO', fr: 'Angola', en: 'Angola'},
    {value: 'AI', fr: 'Anguilla', en: 'Anguilla'},
    {value: 'AQ', fr: 'Antarctique', en: 'Antarctica'},
    {value: 'AG', fr: 'Antigua et Barbuda', en: 'Antigua and Barbuda'},
    {value: 'AN', fr: 'Antilles néerlandaises', en: 'Netherlands Antilles'},
    {value: 'SA', fr: 'Arabie Saoudite', en: 'Saudi Arabia'},
    {value: 'AR', fr: 'Argentine', en: 'Argentina'},
    {value: 'AM', fr: 'Arménie', en: 'Armenia'},
    {value: 'AW', fr: 'Aruba', en: 'Aruba'},
    {value: 'AU', fr: 'Australie', en: 'Australia'},
    {value: 'AT', fr: 'Autriche', en: 'Austria'},
    {value: 'AZ', fr: 'Azerbaïdjan', en: 'Azerbaijan'},
    {value: 'BS', fr: 'Bahamas', en: 'Bahamas'},
    {value: 'BH', fr: 'Bahreïn', en: 'Bahrain'},
    {value: 'BD', fr: 'Bangladesh', en: 'Bangladesh'},
    {value: 'BB', fr: 'Barbade', en: 'Barbados'},
    {value: 'BE', fr: 'Belgique', en: 'Belgium'},
    {value: 'BZ', fr: 'Belize', en: 'Belize'},
    {value: 'BJ', fr: 'Bénin', en: 'Benin'},
    {value: 'BM', fr: 'Bermudes', en: 'Bermuda'},
    {value: 'BT', fr: 'Bhutan', en: 'Bhutan'},
    {value: 'BY', fr: 'Biélorussie', en: 'Belarus'},
    {value: 'BO', fr: 'Bolivie', en: 'Bolivia'},
    {value: 'BA', fr: 'Bosnie-Herzégovine', en: 'Bosnia and Herzegovina'},
    {value: 'BW', fr: 'Botswana', en: 'Botswana'},
    {value: 'BV', fr: 'Bouvet (Île)', en: 'Bouvet Island'},
    {value: 'BR', fr: 'Brésil', en: 'Brazil'},
    {value: 'BN', fr: 'Brunei', en: 'Brunei'},
    {value: 'BG', fr: 'Bulgarie', en: 'Bulgaria'},
    {value: 'BF', fr: 'Burkina Faso', en: 'Burkina Faso'},
    {value: 'BI', fr: 'Burundi', en: 'Burundi'},
    {value: 'KY', fr: 'Caïmans (Îles)', en: 'Cayman Islands'},
    {value: 'KH', fr: 'Cambodge', en: 'Cambodia'},
    {value: 'CM', fr: 'Cameroun', en: 'Cameroon'},
    {value: 'CA', fr: 'Canada', en: 'Canada'},
    {value: 'CV', fr: 'Cap Vert', en: 'Cape Verde'},
    {value: 'CL', fr: 'Chili', en: 'Chile'},
    {value: 'CN', fr: 'Chine', en: 'China'},
    {value: 'CX', fr: 'Christmas (Îles)', en: 'Christmas Island'},
    {value: 'CY', fr: 'Chypre', en: 'Cyprus'},
    {value: 'CC', fr: 'Cocos', en: 'Cocos (Keeling) Islands'},
    {value: 'CO', fr: 'Colombie', en: 'Colombia'},
    {value: 'KM', fr: 'Comores', en: 'Comoros'},
    {value: 'CG', fr: 'Congo', en: 'Congo'},
    {value: 'CD', fr: 'Congo, République démocratique du (Congo)', en: 'Congo, Democratic Republic of the'},
    {value: 'CK', fr: 'Cook (Îles)', en: 'Cook Islands'},
    {value: 'KP', fr: 'Corée du Nord', en: 'North Korea'},
    {value: 'KR', fr: 'Corée du Sud', en: 'South Korea'},
    {value: 'CR', fr: 'Costa Rica', en: 'Costa Rica'},
    {value: 'CI', fr: "Côte d'Ivoire", en: 'Ivory Coast'},
    {value: 'HR', fr: 'Croatie', en: 'Croatia'},
    {value: 'CU', fr: 'Cuba', en: 'Cuba'},
    {value: 'DK', fr: 'Danemark', en: 'Denmark'},
    {value: 'UM', fr: 'Dépendances américaines du Pacifique', en: 'United States Minor Outlying Islands'},
    {value: 'DJ', fr: 'Djibouti', en: 'Djibouti'},
    {value: 'DM', fr: 'Dominique', en: 'Dominica'},
    {value: 'EG', fr: 'Égypte', en: 'Egypt'},
    {value: 'AE', fr: 'Émirats Arabes Unis', en: 'United Arab Emirates'},
    {value: 'EC', fr: 'Équateur', en: 'Ecuador'},
    {value: 'ER', fr: 'Érythrée', en: 'Eritrea'},
    {value: 'ES', fr: 'Espagne', en: 'Spain'},
    {value: 'EE', fr: 'Estonie', en: 'Estonia'},
    {value: 'US', fr: 'États-Unis', en: 'United States'},
    {value: 'ET', fr: 'Éthiopie', en: 'Ethiopia'},
    {value: 'FO', fr: 'Faroe (Îles)', en: 'Faroe Islands'},
    {value: 'FJ', fr: 'Fidji', en: 'Fiji'},
    {value: 'FI', fr: 'Finlande', en: 'Finland'},
    {value: 'FR', fr: 'France', en: 'France'},
    {value: 'GA', fr: 'Gabon', en: 'Gabon'},
    {value: 'GM', fr: 'Gambie', en: 'Gambia'},
    {value: 'GE', fr: 'Géorgie', en: 'Georgia'},
    {value: 'GS', fr: 'Géorgie du Sud et îles Sandwich du Sud', en: 'South Georgia and the South Sandwich Islands'},
    {value: 'GH', fr: 'Ghana', en: 'Ghana'},
    {value: 'GI', fr: 'Gibraltar', en: 'Gibraltar'},
    {value: 'GR', fr: 'Grèce', en: 'Greece'},
    {value: 'GD', fr: 'Grenade', en: 'Grenada'},
    {value: 'GL', fr: 'Groenland', en: 'Greenland'},
    {value: 'GP', fr: 'Guadeloupe', en: 'Guadeloupe'},
    {value: 'GU', fr: 'Guam', en: 'Guam'},
    {value: 'GT', fr: 'Guatemala', en: 'Guatemala'},
    {value: 'GG', fr: 'Guernesey', en: 'Guernsey'},
    {value: 'GN', fr: 'Guinée', en: 'Guinea'},
    {value: 'GW', fr: 'Guinée-Bissau', en: 'Guinea-Bissau'},
    {value: 'GQ', fr: 'Guinée équatoriale', en: 'Equatorial Guinea'},
    {value: 'GY', fr: 'Guyane', en: 'Guyana'},
    {value: 'GF', fr: 'Guyane française', en: 'French Guiana'},
    {value: 'HT', fr: 'Haïti', en: 'Haiti'},
    {value: 'HM', fr: 'Heard et McDonald (Îles)', en: 'Heard Island and McDonald Islands'},
    {value: 'HN', fr: 'Honduras', en: 'Honduras'},
    {value: 'HK', fr: 'Hong-Kong', en: 'Hong Kong'},
    {value: 'HU', fr: 'Hongrie', en: 'Hungary'},
    {value: 'VG', fr: 'Îles vierges britanniques', en: 'British Virgin Islands'},
    {value: 'IN', fr: 'Inde', en: 'India'},
    {value: 'INN', fr: 'Inde du Nord Delhi', en: 'India - North Delhi'},
    {value: 'INS', fr: 'Inde du Sud', en: 'India - South'},
    {value: 'ID', fr: 'Indonésie', en: 'Indonesia'},
    {value: 'IQ', fr: 'Irak', en: 'Iraq'},
    {value: 'IR', fr: 'Iran', en: 'Iran'},
    {value: 'IE', fr: 'Irlande', en: 'Ireland'},
    {value: 'IS', fr: 'Islande', en: 'Iceland'},
    {value: 'IL', fr: 'Israël', en: 'Israel'},
    {value: 'IT', fr: 'Italie', en: 'Italy'},
    {value: 'JM', fr: 'Jamaïque', en: 'Jamaica'},
    {value: 'JP', fr: 'Japon', en: 'Japan'},
    {value: 'JE', fr: 'Jersey', en: 'Jersey'},
    {value: 'JO', fr: 'Jordanie', en: 'Jordan'},
    {value: 'KZ', fr: 'Kazakhstan', en: 'Kazakhstan'},
    {value: 'KE', fr: 'Kenya', en: 'Kenya'},
    {value: 'KG', fr: 'Kirghizistan', en: 'Kyrgyzstan'},
    {value: 'KI', fr: 'Kiribati', en: 'Kiribati'},
    {value: 'KW', fr: 'Koweït', en: 'Kuwait'},
    {value: 'LA', fr: 'Laos', en: 'Laos'},
    {value: 'LS', fr: 'Lesotho', en: 'Lesotho'},
    {value: 'LV', fr: 'Lettonie', en: 'Latvia'},
    {value: 'LB', fr: 'Liban', en: 'Lebanon'},
    {value: 'LR', fr: 'Liberia', en: 'Liberia'},
    {value: 'LY', fr: 'Libye', en: 'Libya'},
    {value: 'LI', fr: 'Liechtenstein', en: 'Liechtenstein'},
    {value: 'LT', fr: 'Lituanie', en: 'Lithuania'},
    {value: 'LU', fr: 'Luxembourg', en: 'Luxembourg'},
    {value: 'MO', fr: 'Macao', en: 'Macao'},
    {value: 'MK', fr: 'Macédoine', en: 'North Macedonia'},
    {value: 'MG', fr: 'Madagascar', en: 'Madagascar'},
    {value: 'MY', fr: 'Malaisie', en: 'Malaysia'},
    {value: 'MW', fr: 'Malawi', en: 'Malawi'},
    {value: 'MV', fr: 'Maldives', en: 'Maldives'},
    {value: 'ML', fr: 'Mali', en: 'Mali'},
    {value: 'FK', fr: 'Malouines (Îles)', en: 'Falkland Islands'},
    {value: 'MT', fr: 'Malte', en: 'Malta'},
    {value: 'IM', fr: 'Man (Île)', en: 'Isle of Man'},
    {value: 'MP', fr: 'Mariannes du Nord (Commonwealth des îles)', en: 'Northern Mariana Islands'},
    {value: 'MA', fr: 'Maroc', en: 'Morocco'},
    {value: 'MH', fr: 'Marshall (Îles)', en: 'Marshall Islands'},
    {value: 'MQ', fr: 'Martinique', en: 'Martinique'},
    {value: 'MU', fr: 'Maurice (Île)', en: 'Mauritius'},
    {value: 'MR', fr: 'Mauritanie', en: 'Mauritania'},
    {value: 'YT', fr: 'Mayotte', en: 'Mayotte'},
    {value: 'MX', fr: 'Mexique', en: 'Mexico'},
    {value: 'FM', fr: 'Micronésie', en: 'Micronesia'},
    {value: 'MD', fr: 'Moldavie', en: 'Moldova'},
    {value: 'MC', fr: 'Monaco', en: 'Monaco'},
    {value: 'MN', fr: 'Mongolie', en: 'Mongolia'},
    {value: 'ME', fr: 'Monténégro', en: 'Montenegro'},
    {value: 'MS', fr: 'Montserrat', en: 'Montserrat'},
    {value: 'MZ', fr: 'Mozambique', en: 'Mozambique'},
    {value: 'MM', fr: 'Myanmar', en: 'Myanmar'},
    {value: 'NA', fr: 'Namibie', en: 'Namibia'},
    {value: 'NR', fr: 'Nauru', en: 'Nauru'},
    {value: 'NP', fr: 'Népal', en: 'Nepal'},
    {value: 'NI', fr: 'Nicaragua', en: 'Nicaragua'},
    {value: 'NE', fr: 'Niger', en: 'Niger'},
    {value: 'NG', fr: 'Nigéria', en: 'Nigeria'},
    {value: 'NU', fr: 'Niue', en: 'Niue'},
    {value: 'NF', fr: 'Norfolk (Île de)', en: 'Norfolk Island'},
    {value: 'NO', fr: 'Norvège', en: 'Norway'},
    {value: 'NC', fr: 'Nouvelle-Calédonie', en: 'New Caledonia'},
    {value: 'NZ', fr: 'Nouvelle-Zélande', en: 'New Zealand'},
    {value: 'OM', fr: 'Oman', en: 'Oman'},
    {value: 'UG', fr: 'Ouganda', en: 'Uganda'},
    {value: 'UZ', fr: 'Ouzbékistan', en: 'Uzbekistan'},
    {value: 'PK', fr: 'Pakistan', en: 'Pakistan'},
    {value: 'PW', fr: 'Palau', en: 'Palau'},
    {value: 'PA', fr: 'Panama', en: 'Panama'},
    {value: 'PG', fr: 'Papouasie-Nouvelle Guinée', en: 'Papua New Guinea'},
    {value: 'PY', fr: 'Paraguay', en: 'Paraguay'},
    {value: 'NL', fr: 'Pays-Bas', en: 'Netherlands'},
    {value: 'PE', fr: 'Pérou', en: 'Peru'},
    {value: 'PH', fr: 'Philippines', en: 'Philippines'},
    {value: 'PN', fr: 'Pitcairn (Île)', en: 'Pitcairn Islands'},
    {value: 'PL', fr: 'Pologne', en: 'Poland'},
    {value: 'PF', fr: 'Polynésie française', en: 'French Polynesia'},
    {value: 'PR', fr: 'Porto Rico', en: 'Puerto Rico'},
    {value: 'PT', fr: 'Portugal', en: 'Portugal'},
    {value: 'QA', fr: 'Qatar', en: 'Qatar'},
    {value: 'CF', fr: 'République Centrafricaine', en: 'Central African Republic'},
    {value: 'DO', fr: 'République Dominicaine', en: 'Dominican Republic'},
    {value: 'CZ', fr: 'République Tchèque', en: 'Czech Republic'},
    {value: 'RE', fr: 'Réunion (Île de la)', en: 'Réunion'},
    {value: 'RO', fr: 'Roumanie', en: 'Romania'},
    {value: 'GB', fr: 'Royaume-Uni', en: 'United Kingdom'},
    {value: 'RU', fr: 'Russie', en: 'Russia'},
    {value: 'RW', fr: 'Rwanda', en: 'Rwanda'},
    {value: 'EH', fr: 'Sahara oriental', en: 'Western Sahara'},
    {value: 'SH', fr: 'Sainte-Hélène', en: 'Saint Helena'},
    {value: 'LC', fr: 'Sainte-Lucie', en: 'Saint Lucia'},
    {value: 'KN', fr: 'Saint-Kitts-et-Nevis', en: 'Saint Kitts and Nevis'},
    {value: 'SM', fr: 'Saint-Marin', en: 'San Marino'},
    {value: 'PM', fr: 'Saint-Pierre-et-Miquelon', en: 'Saint Pierre and Miquelon'},
    {value: 'VC', fr: 'Saint-Vincent et les Grenadines', en: 'Saint Vincent and the Grenadines'},
    {value: 'SV', fr: 'Salvador', en: 'El Salvador'},
    {value: 'WS', fr: 'Samoa', en: 'Samoa'},
    {value: 'AS', fr: 'Samoa américaines', en: 'American Samoa'},
    {value: 'ST', fr: 'São Tomé et Príncipe', en: 'São Tomé and Príncipe'},
    {value: 'SN', fr: 'Sénégal', en: 'Senegal'},
    {value: 'RS', fr: 'Serbie', en: 'Serbia'},
    {value: 'CS', fr: 'Serbie et Monténégro', en: 'Serbia and Montenegro'},
    {value: 'SC', fr: 'Seychelles', en: 'Seychelles'},
    {value: 'SL', fr: 'Sierra Leone', en: 'Sierra Leone'},
    {value: 'SG', fr: 'Singapour', en: 'Singapore'},
    {value: 'SK', fr: 'Slovaquie', en: 'Slovakia'},
    {value: 'SI', fr: 'Slovénie', en: 'Slovenia'},
    {value: 'SB', fr: 'Solomon', en: 'Solomon Islands'},
    {value: 'SO', fr: 'Somalie', en: 'Somalia'},
    {value: 'SD', fr: 'Soudan', en: 'Sudan'},
    {value: 'LK', fr: 'Sri Lanka', en: 'Sri Lanka'},
    {value: 'SE', fr: 'Suède', en: 'Sweden'},
    {value: 'CH', fr: 'Suisse', en: 'Switzerland'},
    {value: 'SR', fr: 'Surinam', en: 'Suriname'},
    {value: 'SJ', fr: 'Svalbard et Jan Mayen', en: 'Svalbard and Jan Mayen'},
    {value: 'SZ', fr: 'Swaziland', en: 'Eswatini'},
    {value: 'SY', fr: 'Syrie', en: 'Syria'},
    {value: 'TJ', fr: 'Tadjikistan', en: 'Tajikistan'},
    {value: 'TW', fr: 'Taïwan', en: 'Taiwan'},
    {value: 'TZ', fr: 'Tanzanie', en: 'Tanzania'},
    {value: 'TD', fr: 'Tchad', en: 'Chad'},
    {value: 'IO', fr: "Territoires britanniques de l'Océan Indien", en: 'British Indian Ocean Territory'},
    {value: 'TF', fr: "Territoires d'Outre-mer (France)", en: 'French Overseas Territories'},
    {value: 'PS', fr: 'Territoires palestiniens', en: 'Palestinian Territories'},
    {value: 'TH', fr: 'Thaïlande', en: 'Thailand'},
    {value: 'THB', fr: 'Thaïlande - Ayutthaya', en: 'Thailand - Ayutthaya'},
    {value: 'THC', fr: 'Thaïlande Chiang Mai/Nong Khai', en: 'Thailand - Chiang Mai/Nong Khai'},
    {value: 'TL', fr: 'Timor oriental', en: 'Timor-Leste'},
    {value: 'TG', fr: 'Togo', en: 'Togo'},
    {value: 'TK', fr: 'Tokelau', en: 'Tokelau'},
    {value: 'TO', fr: 'Tonga', en: 'Tonga'},
    {value: 'TT', fr: 'Trinidad et Tobago (Trinidad and Tobago)', en: 'Trinidad and Tobago'},
    {value: 'TN', fr: 'Tunisie', en: 'Tunisia'},
    {value: 'TM', fr: 'Turkménistan', en: 'Turkmenistan'},
    {value: 'TC', fr: 'Turks et Caïcos (Îles)', en: 'Turks and Caicos Islands'},
    {value: 'TR', fr: 'Turquie', en: 'Turkey'},
    {value: 'TV', fr: 'Tuvalu', en: 'Tuvalu'},
    {value: 'UA', fr: 'Ukraine', en: 'Ukraine'},
    {value: 'UY', fr: 'Uruguay', en: 'Uruguay'},
    {value: 'VU', fr: 'Vanuatu', en: 'Vanuatu'},
    {value: 'VA', fr: 'Vatican', en: 'Vatican City'},
    {value: 'VE', fr: 'Venezuela', en: 'Venezuela'},
    {value: 'VI', fr: 'Vierges américaines (Îles)', en: 'US Virgin Islands'},
    {value: 'VN', fr: 'Vietnam', en: 'Vietnam'},
    {value: 'VNH', fr: 'Vietnam Hanoi', en: 'Vietnam - Hanoi'},
    {value: 'VNC', fr: 'Vietnam Ho Chi Minh', en: 'Vietnam - Ho Chi Minh'},
    {value: 'WF', fr: 'Wallis et Futuna', en: 'Wallis and Futuna'},
    {value: 'YE', fr: 'Yémen', en: 'Yemen'},
    {value: 'ZM', fr: 'Zambie', en: 'Zambia'},
    {value: 'ZW', fr: 'Zimbabwe', en: 'Zimbabwe'},
    {value: 'BO1', fr: 'Bolivie - humanitaire', en: 'Bolivia - humanitarian'},
    {value: 'BO2', fr: 'Bolivie - éco-volontariat', en: 'Bolivia - eco-volunteering'},
    {value: 'EC1', fr: 'Equateur - humanitaire', en: 'Ecuador - humanitarian'},
    {value: 'EC2', fr: 'Equateur - éco-volontariat', en: 'Ecuador - eco-volunteering'},
    {value: 'IG1', fr: 'Iles Galapagos', en: 'Galapagos Islands'},
    {value: 'LKEL', fr: 'Sri Lanka – Eléphants', en: 'Sri Lanka – Elephants'},
    {value: 'AEVO', fr: 'Australie – écovolontariat', en: 'Australia – eco-volunteering'},
    {value: 'ZA1', fr: 'Afrique du Sud - Soins animaliers', en: 'South Africa - Animal care'},
    {value: 'ZA2', fr: 'Afrique du Sud - Faune sauvage', en: 'South Africa - Wildlife'},
    {value: 'IB', fr: 'Majorque', en: 'Mallorca'},
    {value: 'LKETO', fr: 'Sri Lanka - Tortues', en: 'Sri Lanka - Turtles'},
    {value: 'EUCHV', fr: 'Etats-Unis - chevaux', en: 'United States - Horses'},
    {value: 'IHMAYA', fr: 'Inde - Himalaya', en: 'India - Himalaya'},
    {value: 'TZANZI', fr: 'Tanzanie - Zanzibar', en: 'Tanzania - Zanzibar'},
    {value: 'THD', fr: 'Thaïlande - animaux', en: 'Thailand - Animals'},
    {value: 'THE', fr: 'Thaïlande - Udon Thani', en: 'Thailand - Udon Thani'},
    {value: 'THBCM', fr: 'Thaïlande - Bangkok/Chiang Mai', en: 'Thailand - Bangkok/Chiang Mai'},
];

export function getCountryLabel(country) {
    return LANG === 'en' ? country.en : country.fr;
}

// Normalisation pour la recherche dans les <Select> pays/nationalité :
// insensible à la casse et aux accents (« bresil » trouve « Brésil »,
// « etats » trouve « États-Unis »).
function deburr(str) {
    return String(str).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

// Texte indexé pour la recherche : les DEUX libellés (fr + en) plus la valeur
// canonique. L'interface peut être en anglais alors que l'utilisateur tape en
// français — « bresil » doit trouver « Brazil ».
export function countrySearchText(country) {
    return deburr(country.fr + ' ' + country.en + ' ' + country.value);
}

export function filterCountryOption(input, option) {
    const haystack = option['data-search'] || deburr(option.children);
    return haystack.indexOf(deburr(input)) >= 0;
}
